import { render, staticRenderFns } from "./VerificationForm.vue?vue&type=template&id=32f53f37&scoped=true&"
import script from "./VerificationForm.vue?vue&type=script&lang=ts&"
export * from "./VerificationForm.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationForm.vue?vue&type=style&index=0&id=32f53f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f53f37",
  null
  
)

export default component.exports